import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, paramCheck } from '../utils';

export interface SaveImageOption extends Partial<GeneralInvokeOption> {
  content: string;
  invalidParamObj?: '';
}

// 保存图片到相册
export function saveImage(option: SaveImageOption) {
  if (!option.content) {
    return logErrorAndRunFail(
      APINames.Native.SAVE_IMAGE,
      option,
      'parameter error:parameter.content should be String instead of Undefined.'
    );
  }
  if (paramCheck(APINames.Native.SAVE_IMAGE, option, { content: '' })) {
    return MacleJSBridge.beforeInvoke(APINames.Native.SAVE_IMAGE, option);
  }
  return option.invalidParamObj;
}
